<template>
  <div class="user_wrap">
    <div class="top_header">
      <router-link
        to="/sign"
        class="set_go"
      />
      <div class="user_detail">
        <div class="user_header">
          <img
            :src="data.user_icon"
            alt=""
          >
        </div>
        <div class="user_name">
          <div class="user_all">
            <p class="user_nickname" 
			style="color: #fff; "
			>
              {{ data.name?data.name:data.mobile }}
            </p>
          </div>
        </div>
      </div>
      <div class="user_vip"
	  style="color: #ffd01e; "
	  >
        <p>{{ $t('user.welcome') }}{{ data.vip_name }}</p>
      </div>

      <div class="user_zrzcw">
        <div
          v-if="eye==1"
          class="user_balance"
        >
          <div style="font-size: 20px;color: #fff;">
            {{ $t('user.totalBalance') }}
            <van-icon
              name="eye-o"
              @click="eye=0"
            />
          </div>
          <div style="font-size: 40px;color: #F44336;">
            <!--{{$t('utils.moneyMark')}}-->{{ data.all_money }}
          </div>
        </div>
        <!--<div class="user_balance" @click="$router.push('/about/10')" >
			<div>
				{{$t('index.search')}}
				
			</div>
			<div>
				3888
			</div>
		</div>-->
      </div>
      <!--<div
        v-if="eye==1"
        class="user_balance"
      >
        <div>
          {{ $t('user.totalBalance') }}
          <van-icon
            name="eye-o"
            @click="eye=0"
          />
        </div>
        <div>
          {{$t('utils.moneyMark')}}{{ data.all_money }}
        </div>
      </div>-->

      <div
        v-if="eye==0"
        class="user_balance"
      >
        <div>
          {{ $t('user.totalBalance') }}
          <van-icon
            name="closed-eye"
            @click="eye=1"
          />
        </div>
        <div>
          ******
        </div>
      </div>
      <div
        v-if="eye==1"
        class="user_money"
      >
        <div>
          <p>{{ $t('user.uncollectedPrincipal') }}</p>
          <p>+<!--{{$t('utils.moneyMark')}}-->{{ data.wait_money }}</p>
        </div>
        <div>
          <p>{{ $t('user.uncollectedInterest') }}</p>
          <p>+<!--{{$t('utils.moneyMark')}}-->{{ data.wait_lixi }}</p>
        </div>
        <div>
          <p>{{ $t('user.cumulativeIncome') }}</p>
          <p>+<!--{{$t('utils.moneyMark')}}-->{{ data.all_lixi }}</p>
        </div>
        <div>
          <p>{{ $t('pagea.jf') }}</p>
          <p><!--{{$t('utils.moneyMark')}}-->{{ data.score }}</p>
        </div>
      </div>
      <div
        v-if="eye==0"
        class="user_money"
      >
        <div>
          <p>{{ $t('user.uncollectedPrincipal') }}</p>
          <p>******</p>
        </div>
        <div>
          <p>{{ $t('user.uncollectedInterest') }}</p>
          <p>******</p>
        </div>
        <div>
          <p>{{ $t('user.cumulativeIncome') }}</p>
          <p>******</p>
        </div>
        <div>
          <p>{{ $t('pagea.jf') }}</p>
          <p>******</p>
        </div>
      </div>
    </div>
    <div class="kong" />
    <div class="user_yw">
      <div @click="$router.push('/order')">
        <img
          src="../images/user/order.png"
          alt=""
        >
        <p>{{ $t('user.myInvestment') }}</p>
      </div>
	  <div @click="$router.push('/jifenshop')">
	    <img
	      src="../images/user/jfsc.png"
	      alt=""
			style="width: 26px;height: 26px;"
	    >
	    <p>{{ $t('pagea.jfsc') }}</p>
	  </div>
      <!-- <div @click="$router.push('/item')">
        <img
          src="../images/user/details.png"
          alt=""
        >
        <p>{{ $t('search.history') }}</p>
      </div> -->
      <div @click="$router.push('/myTeam')">
        <img
          src="../images/about/icon8.png"
          alt=""
        >
        <p>{{ $t('index.invite') }}</p>
      </div>
    </div>
    <div class="money">
      <div>
        <p>{{ $t('user.availableBalance') }}</p>
        <p><!--{{$t('utils.moneyMark')}}-->{{ data.money }}</p>
      </div>
      <div>
        <span @click="$router.push('/invest')">{{ $t('user.recharge') }}</span>
        <span @click="$router.push('/cash')">{{ $t('user.withdraw') }}</span>
      </div>
    </div>
    <div class="list">
      <!-- <van-cell 
	  style="position: relative; display: flex; box-sizing: border-box; width: 100%; padding: 10px 16px; overflow: hidden; color: #323233; font-size: 14px; line-height: 24px;box-shadow: 0 0 1px 0 #0e298d; color: #fff;background: #0e298d;"
        is-link
        @click="$router.push('/jifenshop')"
      >
        <template #title>
          <img
            src="../images/user/jfsc.png"
            alt=""
			style="width: 26px;height: 26px;"
          >
          <span class="custom-title">{{ $t('pagea.jfsc') }}</span>
        </template>
      </van-cell> -->
      <van-cell 
	  style="position: relative; display: flex; box-sizing: border-box; width: 100%; padding: 10px 16px; overflow: hidden; color: #323233; font-size: 14px; line-height: 24px;box-shadow: 0 0 1px 0 #0e298d; color: #fff;background: #0e298d;"
        is-link
        @click="$router.push('/mygoods')"
      >
        <template #title>
          <img
            src="../images/user/jfdh.png"
            alt=""
			style="width: 26px;height: 26px;"
          >
          <span class="custom-title">{{ $t('pagea.jfdh') }}</span>
        </template>
      </van-cell>
      <van-cell 
	  style="position: relative; display: flex; box-sizing: border-box; width: 100%; padding: 10px 16px; overflow: hidden; color: #323233; font-size: 14px; line-height: 24px;box-shadow: 0 0 1px 0 #0e298d; color: #fff;background: #0e298d;"
        is-link
        @click="$router.push('/moneybag')"
      >
        <template #title>
          <img
            src="../images/user/moneybag.png"
            alt=""
          >
          <span class="custom-title">{{ $t('user.transactionDetails') }}</span>
        </template>
      </van-cell>
      <van-cell
	  style="position: relative; display: flex; box-sizing: border-box; width: 100%; padding: 10px 16px; overflow: hidden; color: #323233; font-size: 14px; line-height: 24px;box-shadow: 0 0 1px 0 #0e298d; color: #fff;background: #0e298d;"
	   
        is-link
        @click="$router.push('/rechargeRecord')"
      >
        <template #title>
          <img
            src="../images/user/cz.png"
            alt=""
          >
          <span class="custom-title">{{ $t('user.rechargeRecord') }}</span>
        </template>
      </van-cell>
      <van-cell
	  style="position: relative; display: flex; box-sizing: border-box; width: 100%; padding: 10px 16px; overflow: hidden; color: #323233; font-size: 14px; line-height: 24px;box-shadow: 0 0 1px 0 #0e298d; color: #fff;background: #0e298d;"
	   
        is-link
        @click="$router.push('/withdrawRecord')"
      >
        <template #title>
          <img
            src="../images/user/tx.png"
            alt=""
          >
          <span class="custom-title">{{ $t('user.withdrawalRecord') }}</span>
        </template>
      </van-cell>
      <van-cell 
	  style="position: relative; display: flex; box-sizing: border-box; width: 100%; padding: 10px 16px; overflow: hidden; color: #323233; font-size: 14px; line-height: 24px;box-shadow: 0 0 1px 0 #0e298d; color: #fff;background: #0e298d;"
        is-link
        @click="$router.push('/renzheng')"
      >
        <template #title>
          <img
            src="../images/user/smrz.png"
            alt=""
			style="width: 26px;height: 26px;"
          >
          <span class="custom-title">{{ $t('pagea.smrz') }}</span>
        </template>
      </van-cell>
    </div>
    <div class="list">	
      <van-cell
	  style="position: relative; display: flex; box-sizing: border-box; width: 100%; padding: 10px 16px; overflow: hidden; color: #323233; font-size: 14px; line-height: 24px;box-shadow: 0 0 1px 0 #0e298d; color: #fff;background: #0e298d;"
	   
        is-link
        @click="$router.push('/myTeam')"
      >
        <template #title>
          <img
            src="../images/user/icon9.png"
            alt=""
          >
          <span class="custom-title">{{ $t('share.introduction') }}</span>
        </template>
      </van-cell>
      <van-cell
	  style="position: relative; display: flex; box-sizing: border-box; width: 100%; padding: 10px 16px; overflow: hidden; color: #323233; font-size: 14px; line-height: 24px;box-shadow: 0 0 1px 0 #0e298d; color: #fff;background: #0e298d;"
	   
        is-link
        @click="$router.push('/safe')"
      >
        <template #title>
          <img
            src="../images/user/setting.png"
            alt=""
          >
          <span class="custom-title">{{ $t('user.setting') }}</span>
        </template>
      </van-cell>
    </div>
  </div>
</template>

<script>
	import Vue from 'vue';
	import qs from 'qs';
	import Fetch from '../../utils/fetch';
	import Api from "../../interface/index";
	import {
		Icon,
		Cell, 
		CellGroup 
	} from "vant";

	Vue.use(Cell).use(CellGroup).use(Icon);

	export default {
		name: "User",
		components: {
		},
		data() {
			return {
				data: {},
				eye:1
			};
		},
		created() {
			this.$parent.footer('user');
		},
		mounted() {
			this.start();
		},
		methods: {
			start() {
				Fetch('/user/info').then((r) => {
					this.data = r.data;
				});
			},
		}
	};
</script>

<style lang="less" scoped>
	.user_wrap {
		max-width: 100%;
		overflow: hidden;
	}
	.top_header {
		position: relative;
		width: 100%;
		background-size: 100% 100%;
		.set_go{
			width: 38px;
			height: 38px;
			position: absolute;
			top: 11px;
		}
		
		.set_go {
			right: 14px;
			background: url(../images/user/sign.png) no-repeat center center;
			background-size: 100% 100%;
		}
		.user_detail {
			width: 100%;
			padding: 28px 15px 0 15px;
			top: 34px;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			.user_header {
				width: 40px;
				height: 40px;
				overflow: hidden;
				border-radius: 50%;
				border: 3px solid rgba(255, 255, 255, 0.3);
				img {
					width: 100%;
					height: 100%;
				}
			}
			.user_name {
				margin-left: 3px;
				margin-top: 3px;
				flex: 1;
				display: flex;
				flex-direction: column;
				justify-content: flex-start;
				color: #323233;
				.user_all {
					display: flex;
					justify-content: flex-start;
					align-items: center;
					.user_nickname {
						line-height: 21px;
						font-size: 16px;
						font-weight: bold;
					}
				}
			}
		}
		.user_vip{
			color: #323233;
			font-size: 16px;
			margin: 10px 20px 20px 20px;
		}
		.user_balance{
			text-align: center;
			div{
				margin: 10px 0;
			}
			div:nth-child(1){
				font-size: 14px;
				color: #ffffff;
			}
			div:nth-child(2){
				font-weight: bold;
				font-size: 18px;
				color: #323233;
			}
		}
		.user_money{
			display: flex;
			justify-content: space-between;
			text-align: center;
			p{
				margin: 10px 0;
			}
			div{
				width: 33.33%;
			}
			p:nth-child(1){
				font-size: 14px;
				color: #ff8917;
			}
			p:nth-child(2){
				font-size: 14px;
				color: #fff;
			}
		}
	}
	.kong{
		width: 100%;
	}
	.user_yw{
		display: flex;
		justify-content: space-between;
		text-align: center;
		padding: 15px 0;
		div{
			width: 33.33%;
		}
		p{
			margin-top: 8px;
			color: #07c160;
		}
		img {
			width: 30px;
			height: 30px;
		}
	}
	.money{
		
		    display: flex;
		    justify-content: space-between;
		    width: 96%;
		    background: #0e298d;
		    border-radius: 5px;
		    margin-top: 10px;
		    margin-left: 2%;
		    padding: 15px;
		    box-shadow: 0 0 1px 0 #0e298d;
		    color: #fff;
			
			
		div:nth-child(1){
			width: 40%;
			text-align: left;
			p:nth-child(1){
				color: #999;
				margin-bottom: 10px;
			}
			p:nth-child(2){
				font-size: 14px;
				font-weight: bold;
			}
		}
		div:nth-child(2){
			width: 60%;
			text-align: right;
			margin-top: 12px;
			span{
				padding: 5px 10px;
				border-radius: 5px;
				margin: 0 5px;
			}
			span:nth-child(1){
				color: #000;
				background: #ffcdde;
			}
			span:nth-child(2){
				color: #000;
				background: #2ccc82;
			}
		}
	}
	.list{
		width: 96%;
		margin-left: 2%;
		margin-top: 10px;
		border-radius: 5px;
		img{
			vertical-align: middle;
			height: 30px;
			width: 30px;
			margin-right: 10px;
		}
	}
	.user_zrzcw{
		display: flex;
		justify-content: space-around;
	}
</style>
